import simplifiedLogo from 'assets/images/simplified_logo.svg';
import PropTypes from 'prop-types';
const SimplifiedLogo = ({ sx = {} }) => {
    return <img src={simplifiedLogo} alt="Efetivo Web" width="150" {...sx} />;
};

SimplifiedLogo.propTypes = {
    sx: PropTypes.object
};

export default SimplifiedLogo;
